const API_BASE_URL = '';

class ApiService {
  async makeRequest(endpoint, options = {}) {
    const url = `${API_BASE_URL}/api${endpoint}`;
    
    const config = {
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
      ...options,
    };

    try {
      const response = await fetch(url, config);
      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || `HTTP error! status: ${response.status}`);
      }

      return data;
    } catch (error) {
      console.error('API request failed:', error);
      throw error;
    }
  }

  async submitEarlyAccess(formData) {
    return this.makeRequest('/early-access', {
      method: 'POST',
      body: JSON.stringify(formData),
    });
  }

  async createSubscription(formData) {
    return this.makeRequest('/subscription/create', {
      method: 'POST',
      body: JSON.stringify(formData),
    });
  }

  async googleSignup(idToken, plan, company) {
    return this.makeRequest('/subscription/google-signup', {
      method: 'POST',
      body: JSON.stringify({ idToken, plan, company }),
    });
  }

  async createEnterpriseContact(formData) {
    return this.makeRequest('/subscription/enterprise-contact', {
      method: 'POST',
      body: JSON.stringify(formData),
    });
  }

  async getSubscriptionStatus(email) {
    return this.makeRequest(`/subscription/status/${encodeURIComponent(email)}`);
  }

  async getPricingPlans() {
    return this.makeRequest('/subscription/plans');
  }

  async scheduleDemo(formData) {
    return this.makeRequest('/demo', {
      method: 'POST',
      body: JSON.stringify(formData),
    });
  }

  async healthCheck() {
    return this.makeRequest('/health');
  }
}

const apiService = new ApiService();
export default apiService;
